// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Juegos_container__H2qmc {
  animation: Juegos_init__how7L 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.Juegos_container__H2qmc .Juegos_header__vNxb6 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.Juegos_container__H2qmc .Juegos_header__vNxb6 .Juegos_titleContainer__NT6Jr {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Juegos_container__H2qmc .Juegos_header__vNxb6 .Juegos_titleContainer__NT6Jr h4 {
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin: 0 0 0 10px;
}

.Juegos_container__H2qmc .Juegos_header__vNxb6 .Juegos_titleContainer__NT6Jr .Juegos_add_btn__JQJsb {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  width: 6.5rem;
  text-transform: capitalize;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  margin-left: 10px;
}

.Juegos_container__H2qmc .Juegos_gamesContainer__Gid\\+l {
  animation: Juegos_init__how7L 1s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  min-height: 600px;
  margin-bottom: 50px;
}

.Juegos_container__H2qmc .Juegos_gamesContainer__Gid\\+l .Juegos_itemGame__HHnQw {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  width: 20rem;
  height: 22rem;
  border-radius: 10px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  margin-inline: 20px;
  margin-top: 50px;
}

.Juegos_container__H2qmc .Juegos_gamesContainer__Gid\\+l .Juegos_itemGame__HHnQw .Juegos_gameBackground__M81Ge {
  position: absolute;
  width: 100%;
  top: 0;
  border-radius: 10px;
  object-fit: contain;
  mask-image: linear-gradient(
    180deg,
    rgb(0, 0, 0),
    rgb(0, 0, 0),
    rgb(0, 0, 0),
    rgba(0, 0, 0, 0)
  );
}

.Juegos_container__H2qmc .Juegos_gamesContainer__Gid\\+l .Juegos_itemGame__HHnQw .Juegos_data__6GBwl {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  transition: 0.3s;
  opacity: 1;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
  z-index: 5;
}

.Juegos_container__H2qmc .Juegos_gamesContainer__Gid\\+l .Juegos_disabledGame__x0p-3 .Juegos_gameBackground__M81Ge {
  filter: grayscale(1);
}

.Juegos_container__H2qmc .Juegos_gamesContainer__Gid\\+l .Juegos_itemGame__HHnQw:hover {
  transition: 0.3s;
  scale: 1.05;
  cursor: pointer;
}

.Juegos_container__H2qmc .Juegos_gamesContainer__Gid\\+l .Juegos_itemGame__HHnQw .Juegos_data__6GBwl h4 {
  font-size: 1.5rem;
  font-weight: 400;
  font-family: Roboto, sans-serif;
  margin: 0;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
}

.Juegos_container__H2qmc .Juegos_gamesContainer__Gid\\+l .Juegos_itemGame__HHnQw .Juegos_data__6GBwl > p {
  font-size: 1rem;
  font-weight: 400;
  font-family: Roboto, sans-serif;
  margin: 0;
  margin-bottom: 20px;
  margin-left: 10px;
}

.Juegos_container__H2qmc .Juegos_gamesContainer__Gid\\+l .Juegos_itemGame__HHnQw .Juegos_data__6GBwl .Juegos_options__0Bl\\+M {
  transition: 0.3s;
  display: flex;
  width: 100%;
  opacity: 0;
  height: 0;
  justify-content: space-between;
  align-items: center;
}

.Juegos_container__H2qmc .Juegos_gamesContainer__Gid\\+l .Juegos_disabledGame__x0p-3 .Juegos_data__6GBwl .Juegos_options__0Bl\\+M {
  transition: 0.3s;
  display: flex;
  width: 100%;
  opacity: 1;
  height: 50px;
  justify-content: space-between;
  align-items: center;
}

.Juegos_container__H2qmc .Juegos_gamesContainer__Gid\\+l .Juegos_itemGame__HHnQw .Juegos_data__6GBwl .Juegos_options__0Bl\\+M .Juegos_icon__r3OwO {
  transition: 0.3s;
  font-size: 1.8rem;
  margin-right: 10px;
}

.Juegos_container__H2qmc .Juegos_gamesContainer__Gid\\+l .Juegos_itemGame__HHnQw .Juegos_data__6GBwl .Juegos_options__0Bl\\+M .Juegos_icon__r3OwO:hover {
  transition: 0.3s;
  scale: 1.1;
  filter: saturate(1.4);
}

.Juegos_container__H2qmc .Juegos_gamesContainer__Gid\\+l .Juegos_itemGame__HHnQw .Juegos_data__6GBwl .Juegos_options__0Bl\\+M > p {
  font-size: 1rem;
  font-weight: 400;
  font-family: Roboto, sans-serif;
  margin: 0;
  margin-left: 10px;
}

.Juegos_container__H2qmc .Juegos_gamesContainer__Gid\\+l .Juegos_itemGame__HHnQw:hover .Juegos_data__6GBwl .Juegos_options__0Bl\\+M {
  transition: 0.3s;
  opacity: 1;
  height: 50px;
}

.Juegos_insertPaginate__I4TOx {
  width: 30px;
  height: 30px;
}

.Juegos_insertPaginateButton__OHhka {
  width: 30px;
  height: 30px;
}

/*---Información---*/

.Juegos_container__H2qmc .Juegos_dataContainer__vzGse {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 500px;
}

.Juegos_container__H2qmc .Juegos_dataContainer__vzGse .Juegos_tableContainer__8dQoR {
  animation: Juegos_init__how7L 1s;
  margin-top: 50px;
  margin-bottom: 50px;
  max-height: 80vh;
}

.Juegos_container__H2qmc .Juegos_dataContainer__vzGse .Juegos_tableContainer__8dQoR {
  border-radius: 10px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.Juegos_container__H2qmc .Juegos_dataContainer__vzGse .Juegos_tableContainer__8dQoR .Juegos_iconbtn__O4nyp {
  transition: 0.3s;
  font-size: 1.8rem;
}

.Juegos_container__H2qmc .Juegos_dataContainer__vzGse .Juegos_tableContainer__8dQoR .Juegos_iconbtn__O4nyp:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

@keyframes Juegos_init__how7L {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media screen and (max-width: 500px) {
  .Juegos_container__H2qmc .Juegos_header__vNxb6 .Juegos_titleContainer__NT6Jr h4 {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Juegos/Juegos.module.css"],"names":[],"mappings":"AAAA;EACE,gCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,gCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,mBAAmB;EACnB,mBAAmB;EACnB;;;;;;GAMC;AACH;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8CAA8C;EAC9C,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,UAAU;EACV,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gCAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin: 0 0 0 10px;\n}\n\n.container .header .titleContainer .add_btn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 2.5rem;\n  width: 6.5rem;\n  text-transform: capitalize;\n  border-radius: 5px;\n  font-size: 1rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n  margin-left: 10px;\n}\n\n.container .gamesContainer {\n  animation: init 1s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  min-height: 600px;\n  margin-bottom: 50px;\n}\n\n.container .gamesContainer .itemGame {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  position: relative;\n  width: 20rem;\n  height: 22rem;\n  border-radius: 10px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  margin-inline: 20px;\n  margin-top: 50px;\n}\n\n.container .gamesContainer .itemGame .gameBackground {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  border-radius: 10px;\n  object-fit: contain;\n  mask-image: linear-gradient(\n    180deg,\n    rgb(0, 0, 0),\n    rgb(0, 0, 0),\n    rgb(0, 0, 0),\n    rgba(0, 0, 0, 0)\n  );\n}\n\n.container .gamesContainer .itemGame .data {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-start;\n  transition: 0.3s;\n  opacity: 1;\n  width: 100%;\n  height: 100%;\n  border-radius: 10px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n  z-index: 5;\n}\n\n.container .gamesContainer .disabledGame .gameBackground {\n  filter: grayscale(1);\n}\n\n.container .gamesContainer .itemGame:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  cursor: pointer;\n}\n\n.container .gamesContainer .itemGame .data h4 {\n  font-size: 1.5rem;\n  font-weight: 400;\n  font-family: Roboto, sans-serif;\n  margin: 0;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: 10px;\n}\n\n.container .gamesContainer .itemGame .data > p {\n  font-size: 1rem;\n  font-weight: 400;\n  font-family: Roboto, sans-serif;\n  margin: 0;\n  margin-bottom: 20px;\n  margin-left: 10px;\n}\n\n.container .gamesContainer .itemGame .data .options {\n  transition: 0.3s;\n  display: flex;\n  width: 100%;\n  opacity: 0;\n  height: 0;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .gamesContainer .disabledGame .data .options {\n  transition: 0.3s;\n  display: flex;\n  width: 100%;\n  opacity: 1;\n  height: 50px;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .gamesContainer .itemGame .data .options .icon {\n  transition: 0.3s;\n  font-size: 1.8rem;\n  margin-right: 10px;\n}\n\n.container .gamesContainer .itemGame .data .options .icon:hover {\n  transition: 0.3s;\n  scale: 1.1;\n  filter: saturate(1.4);\n}\n\n.container .gamesContainer .itemGame .data .options > p {\n  font-size: 1rem;\n  font-weight: 400;\n  font-family: Roboto, sans-serif;\n  margin: 0;\n  margin-left: 10px;\n}\n\n.container .gamesContainer .itemGame:hover .data .options {\n  transition: 0.3s;\n  opacity: 1;\n  height: 50px;\n}\n\n.insertPaginate {\n  width: 30px;\n  height: 30px;\n}\n\n.insertPaginateButton {\n  width: 30px;\n  height: 30px;\n}\n\n/*---Información---*/\n\n.container .dataContainer {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 500px;\n}\n\n.container .dataContainer .tableContainer {\n  animation: init 1s;\n  margin-top: 50px;\n  margin-bottom: 50px;\n  max-height: 80vh;\n}\n\n.container .dataContainer .tableContainer {\n  border-radius: 10px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .dataContainer .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 1.8rem;\n}\n\n.container .dataContainer .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .container .header .titleContainer h4 {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Juegos_container__H2qmc`,
	"init": `Juegos_init__how7L`,
	"header": `Juegos_header__vNxb6`,
	"titleContainer": `Juegos_titleContainer__NT6Jr`,
	"add_btn": `Juegos_add_btn__JQJsb`,
	"gamesContainer": `Juegos_gamesContainer__Gid+l`,
	"itemGame": `Juegos_itemGame__HHnQw`,
	"gameBackground": `Juegos_gameBackground__M81Ge`,
	"data": `Juegos_data__6GBwl`,
	"disabledGame": `Juegos_disabledGame__x0p-3`,
	"options": `Juegos_options__0Bl+M`,
	"icon": `Juegos_icon__r3OwO`,
	"insertPaginate": `Juegos_insertPaginate__I4TOx`,
	"insertPaginateButton": `Juegos_insertPaginateButton__OHhka`,
	"dataContainer": `Juegos_dataContainer__vzGse`,
	"tableContainer": `Juegos_tableContainer__8dQoR`,
	"iconbtn": `Juegos_iconbtn__O4nyp`
};
export default ___CSS_LOADER_EXPORT___;
